/**
 * AI image models a user can pick. The key is what's stored in configs; which
 * vendor actually runs it (and what that costs) is the API's business.
 */
export const IMAGE_MODELS = {
  gptImage: { label: 'ChatGPT', description: 'OpenAI GPT Image' },
  nanoBanana: { label: 'Gemini', description: 'Google Nano Banana' },
} as const;

export type ImageModel = keyof typeof IMAGE_MODELS;

export const IMAGE_MODEL_IDS = Object.keys(IMAGE_MODELS) as [ImageModel, ...ImageModel[]];
